import { ClientRequestBase } from "./client_request_base.js";

export class SessionStartRequest extends ClientRequestBase
{
  constructor(
    public userid: string,
    public payload: Record<string, unknown>,
    public sessionid: string | undefined,
    public auth_token?: string,
  )
  {
    super();
  }
}
